import React from 'react';
import GridProductLookup from './index';
import { LookupRow } from './types';

export interface TaskGroupLookupHandlers {
  PegarValorGrid: (row: LookupRow) => void;
  Iconeadd: () => void;
  Iconeditar: (row: LookupRow) => void;
  iconeExcluir?: (row: LookupRow) => void;
}

export function renderTaskGroupLookupGrid(
  handlers: TaskGroupLookupHandlers,
): React.ReactElement {
  return (
    <GridProductLookup
      endPoint="taskgroup/buscar"
      params="%"
      listTitle="Grupos da tarefa"
      listSubtitle="Selecione um grupo ou cadastre um novo."
      newButtonLabel="Novo grupo"
      searchPlaceholder="Pesquisar grupos..."
      PegarValorGrid={handlers.PegarValorGrid}
      Iconeadd={handlers.Iconeadd}
      Iconeditar={handlers.Iconeditar}
      onDelete={handlers.iconeExcluir}
    />
  );
}
